import { Timestamp } from '@bufbuild/protobuf/wkt';
import { DynamicReservoirInfo } from '@wavingroup/aqora-v2-crate/wavin/aqora/v2/reservoir_dynamic_info_pb';
import { aqoraClient } from '~/services/api/aqora-client';

export const getReservoirDynamicInfo = (
  reservoirName: string,
  timestamp?: Timestamp,
): Promise<DynamicReservoirInfo> =>
  aqoraClient.getDynamicReservoirInfo({
    name: reservoirName,
    beforeTime: timestamp,
  });
